import React from 'react';
//import './App.css';
import {
    Route,
    BrowserRouter as Router,
    Switch
} from "react-router-dom";
import Login from './adminComponents/Login';
import ForgotPassword from './adminComponents/ForgotPassword';
import CreateClientBtn from './adminComponents/CreateClientBtn';
import CreateClient from './adminComponents/CreateClient';
import RcTransfer from './adminComponents/RcTransfer';
import VariantMapping from './adminComponents/VariantMapping';
import RcTransferThankyou from './adminComponents/RcTransferThankyou';
import CreateClientEditView from './adminComponents/CreateClientEditView';
import ClientList from './adminComponents/ClientList';
import AuthChk from './adminComponents/AuthChk';
import NotFound from './adminComponents/NotFound';
import PrivacyPolicy from './adminComponents/PrivacyPolicy';
import Logout from './adminComponents/Logout';
import EditCreateClient from './adminComponents/EditCreateClient';
import RCExcelList from './adminComponents/RCExcelList';
import RCEngineExcelList from './adminComponents/RCEngineExcelList';
import Leadreport from './adminComponents/Leadreport';
import RcPrimepdf from './adminComponents/RcPrimepdf';
import challanpdf from './adminComponents/challanPdf';
import RCPrimeReversePdf from './adminComponents/RCPrimeReversePdf';
import Dashboard from './adminComponents/Dashboard';
import ApiError from './adminComponents/ApiError';
import SettingEdit from './adminComponents/SettingEdit';
import SettingView from './adminComponents/SettingView';
import ApiHistory from './adminComponents/ApiHistory';
import ApiHistoryExcel from './adminComponents/ApiHistoryExcel';
import FuelTransmission from './adminComponents/FuelTransmission';
import FuelTransmissionCreate from './adminComponents/FuelTransmissionCreate';
import panFetchPdf from './adminComponents/PanDetailsPdf';
import panExtensivePdf from './adminComponents/PanExtensiveDetailsPdf';
import aadhaarExtractionPdf from './adminComponents/AadhaarExtractionPdf';
import userDelete from './adminComponents/UserDelete';
import basicForgeryPdf from './adminComponents/BasicForgeryPdf';
import advanceForgeryPdf from './adminComponents/AdvanceForgeryPdf';
import userDeleteSuccess from './adminComponents/UserDeleteSuccess';
import userDeleteFailure from './adminComponents/UserDeleteSuccessFailure';
import rtoAppPrivacy from './adminComponents/RtoAppPrivacy';
import ReportList from './adminComponents/ReportList';
import aadhaarFetchDetailsPdf from './adminComponents/AadhaarFetchPdf';
import MasterServices from './adminComponents/masterServices/MasterServices';
import dashboardNew from './adminComponents/DashboardNew';
import DashboardClient from './adminComponents/DashboardClient';
import RcBulkUpload from './adminComponents/RcBulkUpload';
import ChallanBulkUpload from './adminComponents/ChallanBulkUpload';
import UpdateApiSourceOrder from './adminComponents/UpdateApiSourceOrder';
import BUHeadBillingReport from './adminComponents/BUHeadBillingReport';
import AuditHistoryPage from './adminComponents/AuditHistoryPage';
import MobileRCBulkUpload from './adminComponents/MobileRCBluckUpload';
import SourceList from './adminComponents/sourceList/SourceList';
import SourceComment from './adminComponents/sourceList/SourceComment';


function App() {
    // console.log(window.location.pathname);

    return ( <
        React.Fragment >
        <
        Router > {
            window.location.pathname !== '/admin/login' &&
            window.location.pathname !== '/admin/privacy-policy' &&
            window.location.pathname !== '/admin/logout' &&
            window.location.pathname !== '/admin/rto-transfer' &&
            window.location.pathname !== '/admin/rc-transfer' &&
            window.location.pathname !== '/admin/variant-mapping' &&
            window.location.pathname !== '/admin/fuel-transmission-list' &&
            window.location.pathname !== '/admin/fuel-transmission-create' &&
            window.location.pathname !== '/admin/user-delete' &&
            window.location.pathname !== '/admin/user-delete/success' &&
            window.location.pathname !== '/admin/user-delete/failure' &&
            window.location.pathname !== '/admin/rto-app-privacy' &&
            window.location.pathname !== '/admin/api-error' &&
            window.location.pathname !== '/admin/rc-transfer-thankyou' &&
            window.location.pathname !== '/admin/forgot-password' ?
            <
            AuthChk / > : null
        } <
        Switch >

        <
        Route path = "/admin/login"
        strict exact component = {
            Login
        }
        />

        <
        Route path = "/admin/forgot-password"
        strict exact component = {
            ForgotPassword
        }
        />

        <
        Route path = "/admin/create-client-link"
        strict exact component = {
            CreateClientBtn
        }
        />

        <
        Route path = "/admin/create-client"
        strict exact component = {
            CreateClient
        }
        />

        <
        Route path = "/admin/rc-transfer"
        strict exact component = {
            RcTransfer
        }
        />

        <
        Route path = "/admin/variant-mapping"
        strict exact component = {
            VariantMapping
        }
        />
        <Route path="/admin/fuel-transmission-list" strict exact component={FuelTransmission} />
        <Route path="/admin/fuel-transmission-create" strict exact component={FuelTransmissionCreate} />
        <Route path="/admin/user-delete" strict exact component={userDelete} />
        <Route path="/admin/user-delete/success" strict exact component={userDeleteSuccess} />
        <Route path="/admin/user-delete/failure" strict exact component={userDeleteFailure} />
        <Route path="/admin/rto-app-privacy" strict exact component={rtoAppPrivacy} />

        <
        Route path = "/admin/rc-transfer-thankyou"
        strict exact component = {
            RcTransferThankyou
        }
        />

        <
        Route path = "/admin/dashboard"
        strict exact component = {
            dashboardNew
        }
        />
        <Route path = "/admin/dashboard-client" component={DashboardClient} />
        <Route path = "/admin/dashboard-old" component={Dashboard} />
        <Route path = "/admin/setting" component={SettingView} />
        <Route path="/admin/setting-edit" component={SettingEdit} />
        <Route path="/admin/api-history" component={ApiHistory} />
        <Route path="/admin/api-history-excel" component={ApiHistoryExcel} />
        <Route path="/admin/update-api-source-order" component={UpdateApiSourceOrder} />
        <Route path="/admin/master-services" component={MasterServices} />
        <Route path="/admin/source-list" component={SourceList} />
        <Route path="/admin/source/comment/:sourceid" component={SourceComment} />
        <Route path="/admin/audithistorylist" component={AuditHistoryPage} />
        <Route path="/admin/rc-bulk-upload" component={RcBulkUpload} />
        <Route path="/admin/challan-bulk-upload" component={ChallanBulkUpload} />
        <Route path="/admin/bu-head-billing-report" component={BUHeadBillingReport} />
        <Route path="/admin/mobile-rc-bulk-upload" component={MobileRCBulkUpload}/>

        <
        Route path = "/admin/client-list"
        strict exact component = {
            ClientList
        }
        />

        <
        Route path = "/admin/client-edit-view/:someid"
        strict exact component = {
            CreateClientEditView
        }
        />

        <
        Route path = "/admin/privacy-policy"
        strict exact component = {
            PrivacyPolicy
        }
        />

        <
        Route path = "/admin/logout"
        strict exact component = {
            Logout
        }
        /> <
        Route path = "/admin/edit-client-plan/:someid"
        strict exact component = {
            EditCreateClient
        }
        /> <
        Route path = "/admin/rcexcelList/:someid"
        strict exact component = {
            RCExcelList
        }
        />
        <
        Route path = "/admin/reportList"
        strict exact component = {
            ReportList
        }
        />

        <
        Route path = "/admin/rcengineexcelList/:someid"
        strict exact component = {
            RCEngineExcelList
        }
        />

        <
        Route path = "/admin/reports"
        strict exact component = {
            Leadreport
        }
        />
        <
        Route path="/admin/RcPrime"
        strict exact component={
            RcPrimepdf   
        }
        />
        <
        Route path="/admin/challan"
        strict exact component={
            challanpdf  
        }
        />
        <
        Route path="/admin/PanFetchPdf"
        strict exact component={
            panFetchPdf  
        }
        />
        <
        Route path="/admin/PanExtensivePdf"
        strict exact component={
            panExtensivePdf  
        }
        />
        <
        Route path="/admin/AadhaarFetchPdf"
        strict exact component={
            aadhaarFetchDetailsPdf 
        }
        />
        <
        Route path="/admin/AadhaarExtractionPdf"
        strict exact component={
            aadhaarExtractionPdf  
        }
        />
        <
        Route path="/admin/BasicForgeryPdf"
        strict exact component={
            basicForgeryPdf  
        }
        />
        <
        Route path="/admin/AdvanceForgeryPdf"
        strict exact component={
            advanceForgeryPdf  
        }
        />
        <
        Route path="/admin/RCPrimeReversePdf"
        strict exact component={
            RCPrimeReversePdf  
        }
        />
        <Route path = "/admin/api-error" strict exact component={ApiError} />
        <
        Route component = {
            NotFound
        }
        
        /> </Switch> </Router> </React.Fragment >
    );
}

export default App;
